module.exports = __webpack_public_path__ + "img/f777.d783e7ba.jpg";